'use client'

import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import styles from './ua.module.scss'
import StackedPanel from '../panel/StackedPanel'
import PanelBody from '../panel/PanelBody'
import PanelHeader from '../panel/PanelHeader'
import PanelTitle from '../panel/PanelTitle'
import Button from '../button/Button'
import Icon from '../icon/Icon'
import { emitEvent } from '../plugins/EventListener'

const Dropdown = forwardRef((props, ref) => {
  
  const [visible,setVisible] = useState(false)
  const [maxHeight,setMaxHeight] = useState(9999999999)
  
  const ddRef = useRef()

  useEffect(() => {
    if (ddRef?.current) {
      setupDimensions()
      window.addEventListener('resize', handleResize)
    }
  }, [ddRef])

  const handleResize = () => {
    if (ddRef?.current) {
      setupDimensions()
    }
  }

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
  }

  const setupDimensions = () => {
    const rect = ddRef.current.getBoundingClientRect()
    const height = getWindowDimensions().height
    setMaxHeight(height - rect.y - 24)
  }
  
  const toggle = () => {
    setVisible(!visible)
    if (!visible) {
      emitEvent("dd_visible", true)
      if (props.parentId && props.scrollClass) {
        document.getElementById(props.parentId)?.classList.remove(props.scrollClass)
      }
      ddRef.current.focus()
    } else {
      emitEvent("dd_visible", false)
      setTimeout(() => {
        if (props.parentId && props.scrollClass) {
          document.getElementById(props.parentId)?.classList.add(props.scrollClass)
        }
      }, 250)
    }
  }
  
  const hide = (event, force) => {
    if (visible && (force || (!event.currentTarget.contains(event.relatedTarget) && !ddRef.current.contains(event.relatedTarget)))) {
      setTimeout(() => {
        emitEvent("dd_visible", false)
        setVisible(false)
      }, 250)
    }
  }
  
  const show = (event, force) => {
    setVisible(true)
    emitEvent("dd_visible", true)
    if (props.parentId && props.scrollClass) {
      document.getElementById(props.parentId)?.classList.remove(props.scrollClass)
    }
  }

  const onFocus = (e) => {
    e.preventDefault()
  }
  
  useImperativeHandle(ref, () => ({
    toggle, show, hide
  }))
  
  // onBlur={e => visible ? hide(e) : null}
  
  return ( <>
    { (!props.noBackdrop || props.position == 'ta') && 
    <div className={styles.bd + ' ' + (visible ? styles.bd_show : '')}></div>
    }
    <div ref={ddRef} className={ styles.dropdown + ' ' + (visible ? styles.show : '') + ' ' + styles[props.position] + ' ' + styles[props.body]} 
      aria-hidden={!visible} style={{ marginTop: props.offset, maxHeight: maxHeight + "px" }} tabIndex={visible && props.position != 'ta' ? 0 : -1}
      autoFocus={visible} onFocus={e => onFocus(e)} onBlur={e => visible ? hide(e) : null}> 
        { props.title &&
        <PanelHeader className={'max-f-xs'}>
          <PanelTitle leftPad={true} centered={true}>
            <h2>{ props.title }</h2>
          </PanelTitle>
          { visible &&
          <div>
            <Button theme={'icon'} onClick={e => hide(e, true)} label={ 'Close' }>
              <Icon {...props} name="x"></Icon>
            </Button>
          </div>
          }
        </PanelHeader>
        }
        <div className={styles.body}>
          { visible ? props.children : null }
        </div>
    </div>
  </>
  )
  
})

Dropdown.displayName = 'Dropdown';
export default Dropdown